import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenRefreshService } from '../services/token-refresh.service';
import { TokenStorageService } from '../services/token-storage.service';

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(TokenStorageService);
  const tokenRefresh = inject(TokenRefreshService);

  if (req.url.includes('/auth/')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || !tokenStorage.getRefreshToken()) {
        return throwError(() => error);
      }

      return tokenRefresh.refresh().pipe(
        switchMap((response) => {
          tokenRefresh.clearInFlight();

          if (!response.success || !response.data?.token || !response.data?.refreshToken) {
            tokenStorage.clear();
            return throwError(() => error);
          }

          const newToken = `Bearer ${response.data.token}`;
          tokenStorage.setSession(newToken, response.data.refreshToken);

          return next(req.clone({ setHeaders: { Authorization: newToken } }));
        }),
        catchError((refreshError) => {
          tokenRefresh.clearInFlight();
          tokenStorage.clear();
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
